export const environment = {
  production: false,
  apiUrl: 'https://strdevapis.getsiteware.com/api',
  hubUrl: 'https://strdevapis.getsiteware.com/hubs'
};
